module.exports = __webpack_public_path__ + "826c5882f2197645fd9fa5a2a6bd2fe8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/slovakia.png
 ** module id = 676
 ** module chunks = 0
 **/